<app-base-overlay title="Choose a collection">
  <div body class="flex min-h-0 flex-col gap-4">
    <lib-signal-text-field
      label=""
      placeholder="Search collections..."
      [value]="search()"
      [debounceValueChange]="true"
      (valueChange)="onSearchChange($event)" />

    <div class="max-h-[22rem] min-h-[12rem] overflow-y-auto">
      @if (isLoading()) {
        <p class="py-8 text-center text-sm text-slate-500">Loading collections…</p>
      } @else if (isEmpty()) {
        <p class="py-8 text-center text-sm text-slate-500">
          No collections found. Create one in Data Library first.
        </p>
      } @else {
        <ul class="m-0 list-none p-0">
          @for (item of filteredItems(); track item.id) {
            <li>
              <div
                class="flex w-full items-center gap-2 rounded-xl px-1 py-2.5 transition hover:bg-slate-50">
                <button
                  type="button"
                  class="flex min-w-0 flex-1 cursor-pointer items-center gap-3 border-0 bg-transparent p-0 text-left"
                  (click)="selectCollection(item)">
                  <span
                    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-50 text-slate-600">
                    <app-svg-icon src="assets/icons/database-outline.svg" [size]="18" />
                  </span>
                  <span class="min-w-0 flex-1">
                    <span class="block truncate text-sm font-medium text-slate-900">
                      {{ item.name }}
                    </span>
                    <span class="block truncate text-xs text-slate-500">
                      {{ item.key }}
                    </span>
                  </span>
                  <span
                    class="shrink-0 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-600">
                    {{ item.itemCount ?? 0 }} items
                  </span>
                </button>
                <button
                  type="button"
                  class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-slate-500 transition hover:bg-slate-100 hover:text-primary-600"
                  title="Preview data"
                  aria-label="Preview data"
                  (click)="previewCollection(item, $event)">
                  <app-svg-icon src="assets/icons/eye-outline.svg" [size]="16" />
                </button>
                <button
                  type="button"
                  class="inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-lg border-0 bg-transparent text-slate-300 transition hover:bg-slate-100 hover:text-slate-500"
                  aria-label="Select collection"
                  (click)="selectCollection(item)">
                  <app-svg-icon src="assets/icons/chevron-right.svg" [size]="16" />
                </button>
              </div>
            </li>
          }
        </ul>
      }
    </div>
  </div>
</app-base-overlay>
